var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var PropTypes = require('prop-types');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var FindASpecialist = require('./layout/findASpecialist.jsx');

var Find_A_Specialist = createReactClass({
	mixins: [PureRenderMixin],

	componentWillReceiveProps: function(nextProps){
		if(nextProps.auth.token && nextProps.auth.token !== this.props.token
			&& nextProps.auth.token !== this.oldToken
			&& this.props.specialist.specialistPendingAction.actionFnName){
			this.oldToken = nextProps.auth.token;
			this.props[this.props.specialist.specialistPendingAction.actionFnName](...this.props.specialist.specialistPendingAction.actionFnParams, nextProps.auth.token);
			this.props.removeSpecialistPendingAction();
		}
	},

	handleSpecialistUnauthenticatedUser: function(pendingAction){
		this.props.setLoginRedirectUrl(this.props.location.pathname);
		this.context.router.push('/register');

		this.props.setSpecialistPendingAction(pendingAction);
	},

    render: function(){
        return (
            <div className="content">
                <Helmet title='Find a Gi Specialist' />

				<div className="content-header-wrapper">
					<div className="content-header-small content-header row column">
						<h1>Find a Specialist</h1>
					</div>
				</div>

				<Loader loaded={!this.props.specialists.isFetching}>
					<FindASpecialist
						searchSpecialists={this.props.searchSpecialists}
						specialists={this.props.specialists}
						specialist={this.props.specialist}
						setMySpecialist={this.props.setMySpecialist}
						clearMySpecialist={this.props.clearMySpecialist}
						error={this.props.specialists.error}
						clearError={this.props.clearSpecialistsError}
						token={this.props.auth.token}
						handleSpecialistUnauthenticatedUser={this.handleSpecialistUnauthenticatedUser}
						clickTracking={this.props.recordFindASpecialistClick} />
					<p className="powered-by-wrapper">
						<span className="powered-by">Powered by <img src="https://res.cloudinary.com/mytotalhealth/image/upload/v1620165129/web/logo-ACG.png" alt="ACG (American College of Gastroenterology)" /></span>
					</p>
                </Loader>
            </div>
        );
    }
});

Find_A_Specialist.contextTypes = {
  	router: PropTypes.object.isRequired
};

module.exports = Find_A_Specialist;



// WEBPACK FOOTER //
// ./src/common/routes/find-a-specialist/components/find-a-specialist.jsx